/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Source_EveryoneInputs */



/**
* | output |
* | --- |
* | "Everyone (base)" |
*
* @param {Rights_Tools_Source_EveryoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_source_everyone = /** @type {((inputs?: Rights_Tools_Source_EveryoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Source_EveryoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle (Basis)")
	return /** @type {LocalizedString} */ ("Everyone (base)")
});